export const composeAriaLabel = (loading: boolean, loadingLabel: string, baseLabel?: string) => {
  if (!loading) {
    return baseLabel;
  }
  return baseLabel ? `${baseLabel} - ${loadingLabel}` : loadingLabel;
};
